/* ============
 * Routes File
 * ============
 *
 * The routes and redirects are defined in this file.
 */

export default [
    // Home
    {
        path: '/',
        name: 'home.index',
        component: () =>
            import ('@/pages/Home/Index'),

        // If the user needs to be authenticated to view this page
        meta: {
            guest: true,
        },
    },

    // Account
    {
        path: '/admin',
        name: 'admin.index',
        component: () =>
            import ('@/pages/Account/Index'),

        // If the user needs to be authenticated to view this page.
        meta: {
            auth: true,
        },
    },

    // Login
    {
        path: '/login',
        name: 'login.index',
        component: () =>
            import ('@/pages/Login/Index'),

        // If the user needs to be a guest to view this page.
        meta: {
            guest: true,
        },
    },

    // Register
    {
        path: '/register',
        name: 'register.index',
        component: () =>
            import ('@/pages/Register/Index.vue'),

        // If the user needs to be a guest to view this page.
        meta: {
            guest: true,
        },
    },
    {
        path: '/dharmam/:name',
        name: 'dharmam.index',
        props: true,
        component: () =>
            import ('@/pages/Dharmam/Index.vue'),
        // If the user needs to be a guest to view this page.
        meta: {
            guest: true,
        },
    },
    {
        path: '/bank/:name',
        name: 'bank.index',
        props: true,
        component: () =>
            import ('@/pages/Bank/Index.vue'),
        // If the user needs to be a guest to view this page.
        meta: {
            guest: true,
        },
    },
    {
        path: '/dharmams',
        name: 'dharmams.index',
        component: () =>
            import ('@/pages/Dharmams/Index.vue'),
        // If the user needs to be a guest to view this page.
        meta: {
            guest: false,
            auth: true,
        },
    },
    {
        path: '/donation-received',
        name: 'donation.index',
        /*
                query: {
                    payment_id: 'MOJO7b26005A47516785',
                    payment_request_id: '7dbb692ceeeb4d1bbcdc5b85304540fd'
                },*/
        props: (route) => ({
            paymentId: route.query.payment_id,
            requestId: route.query.payment_request_id,
        }),
        component: () =>
            import ('@/pages/Receive/Index.vue'),
        // If the user needs to be a guest to view this page.
        meta: {
            guest: true,
        },
    },
    {
        path: '/*',
        redirect: '/home',
    },
]


// WEBPACK FOOTER //
// ./src/routes/index.js